// Lista de textos curtos editável como "chips" (diferenciais, nunca dizer).
import { useState } from 'react'
import { Plus, X } from 'lucide-react'

export default function TagInput({ value, onChange, placeholder, max = 10, maxLength = 120, disabled, label }: {
  value: string[]
  onChange: (v: string[]) => void
  placeholder: string
  max?: number
  maxLength?: number
  disabled?: boolean
  label: string
}) {
  const [draft, setDraft] = useState('')
  const add = () => {
    const t = draft.trim()
    if (!t || value.some((v) => v.toLowerCase() === t.toLowerCase()) || value.length >= max) return
    onChange([...value, t])
    setDraft('')
  }
  return (
    <div className="stack" style={{ gap: 8 }}>
      {value.length > 0 && (
        <div className="row wrap" style={{ gap: 6 }}>
          {value.map((v) => (
            <span key={v} className="chip small" style={{ maxWidth: '100%' }}>
              <span style={{ overflowWrap: 'anywhere' }}>{v}</span>
              {!disabled && (
                <button type="button" aria-label={`Remover ${v}`} onClick={() => onChange(value.filter((x) => x !== v))} style={{ background: 'none', border: 'none', padding: 0, display: 'inline-flex', color: 'var(--muted)' }}>
                  <X size={14} />
                </button>
              )}
            </span>
          ))}
        </div>
      )}
      {!disabled && value.length < max && (
        <div className="row" style={{ gap: 8 }}>
          <input
            className="input"
            style={{ flex: 1, minWidth: 0 }}
            value={draft}
            maxLength={maxLength}
            placeholder={placeholder}
            aria-label={label}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                add()
              }
            }}
          />
          <button type="button" className="btn" onClick={add} disabled={!draft.trim()} aria-label={`Adicionar em ${label}`}><Plus size={16} /></button>
        </div>
      )}
    </div>
  )
}
